<style lang="scss">
.comps-nav-item {
  padding: 10px;
  > .hd {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-weight: 600;
      color: #333;
      font-size: 13px;
    }
    .btn-text {
      font-size: 13px;
      cursor: default;
    }
  }
  .bd-field {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    display: flex;
    align-items: center;
    .label {
      font-size: 13px;
      width: 60px;
    }
    .field {
      flex: 1;
    }
    .img-wrap {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }
    .img-con {
      width: 60px;
      height: 60px;
    }
    .desc {
      font-size: 12px;
      color: $color-hint-text;
      text-align: center;
      line-height: 14px;
    }
    .img-con-picker {
      width: 56px;
      height: 56px;
      background: #555;
      border-radius: 6px;
      margin-left: -32px;
      position: relative;
      cursor: pointer;
      background-size: cover;
      background-repeat: no-repeat;
      overflow: hidden;
      &:hover {
        span {
          display: block;
        }
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: rgba($color: #555, $alpha: 0.3);
        }
      }
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
        font-size: 12px;
        display: none;
        z-index: 100;
      }
    }
  }
  .btn-edit {
    color: #409eff;
    cursor: default;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
<template>
  <div class="comps-nav-item">
    <div class="hd">
      <span class="title">{{ label }}</span>
      <span
        :class="{
          'btn-text': true,
          'btn-edit':
            value.name != value.default || (value.icon && value.icon != value.defaultMenusIcon)
        }"
        @click="
          reInitVal(
            value.name != value.default || (value.icon && value.icon != value.defaultMenusIcon)
          )
        "
      >恢复默认</span>
    </div>
    <div class="bd">
      <div class="bd-field">
        <div class="label">
          名称
        </div>
        <div class="field">
          <el-input
            v-model="value.name"
            size="small"
            placeholder="请输入内容"
            maxlength="5"
            show-word-limit
          />
        </div>
      </div>
      <div class="bd-field">
        <div class="label">
          图标
        </div>
        <div class="field img-wrap">
          <div
            class="img-con-picker"
            :style="{ backgroundImage: `url(${value.icon || value.defaultMenusIcon})` }"
            @click="handleClickChangeImage"
          >
            <span>替换</span>
          </div>
          <div class="desc">
            建议尺寸<br>100px * 100px
          </div>
        </div>
      </div>
      <div class="bd-field">
        <div class="label">
          是否显示
        </div>
        <div class="field img-wrap">
          <el-switch
            v-model="value.switch"
          />
        </div>
      </div>
    </div>

    <!-- 选择图片 -->
    <SpImageSelect
      :image-visible="showImgPicker"
      :choose-one="true"
      @closeImageDialog="onClosePicker"
      @chooseImage="onChangePicker"
    />
  </div>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    label: String,
    value: Object
  },
  data () {
    const { name, icon } = this.value
    return {
      name,
      icon,
      showImgPicker: false
    }
  },
  mounted () {
    console.log('[NavItem]', this.icon)
  },
  methods: {
    handleClickChangeImage () {
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        this.value.icon = data[0].image_url
      }
      this.$emit('input', {})
    },
    //恢复默认
    reInitVal (type) {
      if (!type) return
      this.$confirm('请确认是否要恢复默认配置', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$emit('reInitVal', true)
      })
    }
  }
}
</script>
